import { useQuery } from '@tanstack/react-query';
import { authQueryKeys } from '../authQueryKeys';
import { userService } from '../../services/UserService';

export function useCurrentUserProfileQuery(enabled: boolean) {
  return useQuery({
    queryKey: authQueryKeys.currentUserProfile(),
    enabled: enabled,
    queryFn: () => userService.getCurrentUser(),
  });
}
